(ns frontend.view.components.power-search.hit.view
  (:require
   [re-frame.core :as rf]
   [frontend.view.components.power-search.event :as event]
   [frontend.view.components.power-search.highlight.view :as highlight]
   [clojure.string :as s]
   [common.opensearch.fields :as cos]
   [reagent.core :as r]
   [frontend.state.current-session :as session]
   [clojure.string :as string]
   [oops.core :as oops]
   [common.localization :as loc]))

(defn experimental-open-in-ribbon-tab-button
  [props]
  (let [entity-id (-> props
                      :hit
                      :_id
                      (js/parseInt))]
    [:div
     {:class "px-2 rounded hover:bg-base-gloomy border"
      :on-click (fn [e]
                  (oops/ocall e "preventDefault")
                  (oops/ocall e "stopPropagation")
                  (rf/dispatch [:frontend.test-ribbon.event/open-nev
                                {:entity-id entity-id
                                 ;; TODO: make dynamic when adding more nev entity types
                                 :entity-type :entity.type/company}])
                  (rf/dispatch [::event/close]))}
     (loc/tr :open-in-ribbon)]))

(defn hit
  [props]
  (let [focused-state (r/atom false)]
    (fn [{:keys [hit tab-index active?]}]
      (let [focused? @focused-state
            entity-type (-> hit
                            :_source
                            :original
                            :entity/type
                            (keyword))]
        [:button
         {:id          (s/join "_"
                               ["universal-search-result-hit"
                                (-> hit
                                    :_source
                                    :original
                                    :entity/type)
                                (:_id hit)])
          :class       "flex hover:text-base-light-text-accent"
          :style       {:background (when active? "#fafafa")}
          :tab-index   tab-index
          :on-focus    (fn [] (reset! focused-state true))
          :on-blur     (fn [] (reset! focused-state false))
          :on-key-down (fn [e] (when (= "Enter" (.-key e)) (.stopPropagation e)))
          :on-click    (fn []
                         (rf/dispatch [::event/select-hit hit]))}
         [:div
          [:div
           (let [name-highlight-text (-> hit
                                         :highlight
                                         (select-keys [:extras.lower-case-display-name])
                                         (vals)
                                         (ffirst))]
             (if name-highlight-text
               [highlight/highlight name-highlight-text]
               (cos/hit->entity-name hit)))]

          (when (and (session/show-experimental-ribbon-features?)
                     (= entity-type :entity.type/company))
            [experimental-open-in-ribbon-tab-button props])

          (let [highlight (-> hit
                              :highlight
                              (dissoc :extras.lower-case-display-name))
                [dot-separated-field-path [highlight-text]]
                (->> highlight
                     (remove
                      (comp cos/dot-separated-entity-name-path? first))
                     (sort-by
                      (comp highlight/highlighted-parts-total-length second))
                     (first))]
            (when highlight-text
              [:div
               [:div
                (cos/dot-separated-path->field-name dot-separated-field-path)
                ":"]
               [:div
                [highlight/highlight highlight-text]]]))]]))))
